export enum ModalVariant {
    small = 'small',
    medium = 'medium',
    large = 'large',
    xlarge = 'xlarge',
}

export type ModalVariantClass = 'modal-sm' | 'modal-md' | 'modal-lg' | 'modal-xl';
